import { api } from 'api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useFaqUpdate = (id: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: any) => {
      return api.faq.update({ ...payload, id: Number(id) })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['faqList'] })

      toaster.create({
        type: 'success',
        title: 'Элемент обновлен успешно',
      })
    },
    onError: (err) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при попытке обновить элемент',
        description: err.message,
      })
    },
  })
}
